export default __webpack_public_path__ + "static/media/CapaContactsActive.d22a1bfb.svg";